import "./scss/styles.scss";
import "./scss/terminal_bootstrap.scss";
import "./scss/responsive.scss";
import "./scss/safi/safi.scss";
import "./scss/maputo/maputo.scss";
import "./Functions/core.js";
